export default __webpack_public_path__ + "static/Cooked_Prime_Meat-8bc4cde4f30c16940ff43468836872c6.png";